/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo } from "react";
import { Link, useParams } from "react-router-dom";

// MRT
import { MaterialReactTable } from "material-react-table";

//import translation function for language translation
import { useTranslation } from "react-i18next";

//import api requiremnts
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";
//import context
import { GlobalProvider } from "context/GlobalContext";
import SurveyFeedbackPopup from "../Popup/SurveyFeedbackPopup";
import SurveyFeedbackThanksModal from "../Modal/SurveyFeedbackThanksModal";
import UserProfileTabBreadCrumb from "../BreadCrumb/UserProfileTabBreadCrumb";

const SurveyFeedbackTab = (props) => {
  const token = localStorage.getItem("token");
  const params = useParams();
  const { screenHeight } = useContext(GlobalProvider);
  const { t } = useTranslation(); //for translation

  const [surveyList, setSurveyList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  const [surveyData, setSurveyData] = useState(null);

  //function for get all survey list
  const getAllSurveyList = async () => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_SURVEY_FEEDBACK +
        `?token=${token}&user=${params.id}`;

      console.log("Url in profile survey list=======>", requestUrl);

      const response = await getData(requestUrl);

      console.log("Response in profile survey list=======>", response);

      if (response.status) {
        setSurveyList(response.data);
        setResponseReceived(true);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  //html for edit button
  const chevronRight = ({ dataItem }) => {
    const surveyPopupHandler = () => {
      setSurveyData(dataItem);
    };
    return (
      <div className="code">
        <Link
          to="#profile_survey_feedback_popup"
          data-bs-toggle="offcanvas"
          onClick={surveyPopupHandler}
        >
          <span className="material-icons-outlined">chevron_right</span>
        </Link>
      </div>
    );
  };

  const statusHTML = ({ dataItem }) => {
    const textColor =
      dataItem.surveyresponsestatus == "1" ? "green_text" : "text-danger";

    return (
      <span className={`start-time ${textColor}`}>{dataItem.surveyresponse}</span>
    );
  };

  //function for after modal close
  const closeModalHandler = () => {
    getAllSurveyList();
  };

  const tableColumns = useMemo(
    () => [
      {
        id: "survey.name",
        accessorFn: (row) => row.survey?.name ?? "",
        header: t("Survey"),
        size: 300,
      },
      {
        id: "surveydate",
        accessorKey: "surveydate",
        header: t("Survey Date"),
        size: 200,
      },
      {
        id: "surveyresponse",
        accessorKey: "surveyresponse",
        header: t("Status"),
        Cell: ({ row }) => statusHTML({ dataItem: row.original }),
        size: 200,
      },
      {
        id: "submittedon",
        accessorKey: "surveydate",
        header: t("Submitted on"),
        size: 200,
      },
      {
        id: "action",
        accessorKey: "action",
        header: t("Action"),
        Cell: ({ row }) => chevronRight({ dataItem: row.original }),
        size: 200,
      },
    ],
    [surveyList]
  );

  useEffect(() => {
    if (responseReceived === false) {
      getAllSurveyList();
    }
  }, [responseReceived]);

  useEffect(() => {
    if (params.id) {
      getAllSurveyList();
    }
  }, [params.id]);

  return (
    <div className="profile_tabInnr">
      <UserProfileTabBreadCrumb
        moduleName="Survey"
        userData={props?.userData}
      />

      <div className="table-responsive py-2 mt-2">
        <MaterialReactTable
          columns={tableColumns}
          data={surveyList}
          enableSorting
          enableFilters
          enableGlobalFilter={false}
          enableGrouping
          enableColumnOrdering
          enableStickyHeader
          enableRowSelection
          onRowSelectionChange={setRowSelection}
          getRowId={(row) => row._id}
          state={{ rowSelection }}
          muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
          muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
          muiTableBodyProps={{ sx: { overflow: "visible" } }}
          initialState={{
            pagination: { pageSize: 100, pageIndex: 0 },
            showColumnFilters: true,
          }}
        />
      </div>
      <SurveyFeedbackPopup
        surveyData={surveyData}
        setSurveyData={setSurveyData}
      />
      <SurveyFeedbackThanksModal closeModalHandler={closeModalHandler} />
    </div>
  );
};

export default SurveyFeedbackTab;
